<!--
# SearchSuggest Component (Legacy)

@deprecated Prefer `TwoFieldSuggest.vue` para o fluxo dois campos.
-->
<script setup lang="ts">
import type {
	NewSearchSuggestProps,
	Suggestion,
	SuggestionCondoResult
} from './types';
import type { SelectAddressEvent } from '~/composables/useNewSearchSuggest';

import SearchSuggestField from './SearchSuggestField.vue';

const props = withDefaults(defineProps<NewSearchSuggestProps>(), {
	isFetchingPropertyByCodeSearch: false,
	enableAnimation: true,
	closeOnClickOutside: true,
	closeOnSelect: true,
	showCloseIcon: false
});

const emit = defineEmits<{
	(e: 'select-address', event: SelectAddressEvent): void;
	(e: 'select-place', value: SelectAddressEvent): void;
	(e: 'select-condo', value: SuggestionCondoResult): void;
	(e: 'select-code', value: Suggestion['searchParams']): void;
	(e: 'update:search-term', value: string): void;
	(e: 'emptyResultOnFilter', searchTerm: string): void;
	(e: 'clear'): void;
	(e: 'close-modal'): void;
}>();

const isDropdownOpened = defineModel<boolean>('isDropdownOpened', {
	default: false
});

const fieldRef =
	useTemplateRef<InstanceType<typeof SearchSuggestField>>('fieldRef');

defineExpose({
	focusInput: (): boolean => fieldRef.value?.focusInput() ?? false
});
</script>

<template>
	<SearchSuggestField
		ref="fieldRef"
		v-bind="props"
		v-model:is-dropdown-opened="isDropdownOpened"
		@select-address="emit('select-address', $event)"
		@select-place="emit('select-place', $event)"
		@select-condo="emit('select-condo', $event)"
		@select-code="emit('select-code', $event)"
		@update:search-term="emit('update:search-term', $event)"
		@empty-result-on-filter="emit('emptyResultOnFilter', $event)"
		@clear="emit('clear')"
		@close-modal="emit('close-modal')"
	>
		<template #input-prefix>
			<slot name="input-prefix" />
		</template>
	</SearchSuggestField>
</template>
